import Component from '@glimmer/component';
import type { WithBoundArgs } from '@glint/template';
import type { HeadlessFormComponentSignature } from 'ember-headless-form/components/headless-form';
import { type UserData } from '../../../types.ts';
import CheckboxFieldComponent from './checkbox.gts';

interface ToggleButtonsSignature<DATA extends UserData> {
  Element: HTMLFieldSetElement;
  Args: {
    legend?: string;
    multiple?: boolean;
    form: HeadlessFormComponentSignature<DATA, unknown>['Blocks']['default'][0];
  };
  Blocks: {
    default: [WithBoundArgs<typeof CheckboxFieldComponent<DATA>, 'form'>];
  };
}

export default class ToggleButtons<DATA extends UserData> extends Component<
  ToggleButtonsSignature<DATA>
> {
  CheckboxFieldComponent: typeof CheckboxFieldComponent<DATA> =
    CheckboxFieldComponent<DATA>;

  <template>
    <fieldset ...attributes>
      {{#if @legend}}
        <legend class='text-pink text-p1 mb-4'>{{@legend}}</legend>
      {{/if}}

      <div class='flex'>
        {{yield
          (component
            this.CheckboxFieldComponent form=@form variant='toggle-button'
          )
        }}
      </div>
    </fieldset>
  </template>
}
